/**
 * Dashboard service
 */
import apiClient from './api';

const dashboardService = {
  /**
   * Get dashboard statistics
   * @returns {Promise<object>}
   */
  async getStats() {
    const response = await apiClient.get('/dashboard/stats');
    return response.data;
  },

  /**
   * Get recent projects
   * @returns {Promise<Array>}
   */
  async getRecentProjects() {
    const response = await apiClient.get('/dashboard/recent-projects');
    return response.data;
  },

  /**
   * Get project stages distribution
   * @returns {Promise<Array>}
   */
  async getProjectStages() {
    try {
      const response = await apiClient.get('/dashboard/project-stages');
      return response.data;
    } catch (error) {
      // This endpoint might not exist, return empty array
      return [];
    }
  },

  /**
   * Get MVP command-center aggregates: bids, procurement, schedule risks,
   * approvals, documents, and AI readiness.
   * @returns {Promise<object>}
   */
  async getCommandCenter() {
    const response = await apiClient.get('/dashboard/command-center');
    return response.data;
  },

  async getRiskQueue() {
    const response = await apiClient.get('/dashboard/risk-queue');
    return response.data;
  },
};

export default dashboardService;
